require("./similar-items.scss");

(function ($) {
    const $contentWrapper = $(".content-wrapper");
    const $selectWrapper = $("[data-similar-items-cmp-dropdown]");

    const url = $("[data-similar-items-cmp]").data("api");
    $.get(url)
        .done(response => {
            $contentWrapper.html(response);
        });

    $contentWrapper.on("change", $selectWrapper, function () {
        const $this = $("[data-similar-items-cmp-dropdown]");
        $.get(url, { locationId: $this.data("locationid"), state: $this.val() })
            .done(response => {
                $contentWrapper.html(response);
            });
    });
})(jQuery);